"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { toast } from "@/lib/toast";
import { Avatar, HStack, Text, VStack } from "@chakra-ui/react";
import { NeynarAuthButton, useNeynarContext } from "@neynar/react";
import { useEffect, useRef } from "react";
interface FarcasterConnectButtonProps {
  onConnect: (data: {
    fid: number;
    signerUuid: string;
    username: string;
  }) => void;
  onDisconnect?: () => void;
}
export function FarcasterConnectButton(t0) {
  const $ = _c(24);
  const {
    onConnect,
    onDisconnect
  } = t0;
  const {
    user,
    isAuthenticated,
    logoutUser
  } = useNeynarContext();
  const hasConnectedRef = useRef(false);
  let t1;
  let t2;
  if ($[0] !== isAuthenticated || $[1] !== onConnect || $[2] !== user) {
    t1 = () => {
      if (isAuthenticated && user && !hasConnectedRef.current) {
        const signerUuid = user.signer_uuid;
        const fid = user.fid;
        const username = user.username || `fid:${fid}`;
        if (signerUuid && fid) {
          hasConnectedRef.current = true;
          onConnect({
            fid,
            signerUuid,
            username
          });
          toast({
            title: "Farcaster Connected",
            description: `Connected as @${username}`,
            status: "success",
            duration: 3000
          });
        }
      }
    };
    t2 = [isAuthenticated, user, onConnect];
    $[0] = isAuthenticated;
    $[1] = onConnect;
    $[2] = user;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== logoutUser || $[6] !== onDisconnect) {
    t3 = () => {
      logoutUser();
      hasConnectedRef.current = false;
      onDisconnect?.();
      toast({
        title: "Disconnected",
        description: "To use a different Farcaster account, open an incognito window or clear cookies for neynar.com",
        status: "warning",
        duration: 8000,
        isClosable: true
      });
    };
    $[5] = logoutUser;
    $[6] = onDisconnect;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleDisconnect = t3;
  if (isAuthenticated && user) {
    const t4 = user.display_name || user.username;
    let t5;
    if ($[8] !== t4 || $[9] !== user.pfp_url) {
      t5 = <Avatar size="sm" src={user.pfp_url} name={t4} />;
      $[8] = t4;
      $[9] = user.pfp_url;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Text fontWeight="bold" color="green.200">Connected</Text>;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== user.fid || $[13] !== user.username) {
      t7 = <VStack align="start" spacing={0} flex={1}>{t6}<Text fontSize="sm" color="gray.300">@{user.username} (FID: {user.fid})</Text></VStack>;
      $[12] = user.fid;
      $[13] = user.username;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== t5 || $[16] !== t7) {
      t8 = <HStack p={4} bg="green.900" borderRadius="md" borderWidth={1} borderColor="green.600">{t5}{t7}</HStack>;
      $[15] = t5;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== handleDisconnect) {
      t9 = <Button size="sm" variant="destructive" onClick={handleDisconnect}>{"Disconnect & Use Different Account"}</Button>;
      $[18] = handleDisconnect;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== t8 || $[21] !== t9) {
      t10 = <VStack spacing={3} align="stretch">{t8}{t9}</VStack>;
      $[20] = t8;
      $[21] = t9;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    return t10;
  }
  let t4;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <VStack spacing={3} align="stretch"><Text fontSize="sm" color="gray.400">Sign in with Farcaster to authorize this app to post on your behalf.</Text><NeynarAuthButton /></VStack>;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
}